import type { HttpInterceptorFn } from '@angular/common/http';
import { cacheInterceptor } from './caching.interceptor';

export const APP_INTERCEPTORS: HttpInterceptorFn[] = [cacheInterceptor];
